import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import { FaqCategory } from '@/api/types/faq.types';

export function mapApiDataToTabs(categories: FaqCategory[], slug: string) {
  return categories.map(category => ({
    id: category.slug,
    label: category.name,
    isActive: category.slug === slug,
  }));
}

export function getQuestionAnchor(id: string) {
  // Keep numeric links from the legacy FAQ while GraphQL returns Rails GlobalIDs.
  return Utf8.stringify(Base64.parse(id)).replace(/^.*\//, '');
}
